import { TextFieldController } from '@components/react-hook-components'
import type { Control, FieldValues, Path } from 'react-hook-form'

type DefaultFeatureValueInputProps<T extends FieldValues> = {
  control: Control<T>
  name: Path<T>
}

export const DefaultFeatureValueInput = <T extends FieldValues>({ control, name }: DefaultFeatureValueInputProps<T>) => {
  return <TextFieldController control={control} name={name} labelText="Value (optional)" />
}
